var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e556788","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMinimizer.vue
// module id = 134
// module chunks = 29